@for (error of errors; track $index) {
    {{customMessage ? customMessage : error}}<br>
}
